module.exports = __webpack_public_path__ + "asset/image-ic_category_30-19ece56e6d42ac11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_30.svg
// module id = WWu0
// module chunks = 0